(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["casland-card-details"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('casland-card-details')) {
  customElements.define('casland-card-details', class extends HTMLElement {
    connectedCallback() {
      this.cache = new Map();
      this.states = new WeakMap();
      this.queue = [];
      this.active = 0;
      this.timer = null;
      this.observer = new MutationObserver(() => {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => this.scan(), 100);
      });
      this.observer.observe(document.body, { childList: true, subtree: true });
      this.scan();
    }
    disconnectedCallback() {
      this.observer.disconnect();
      clearTimeout(this.timer);
    }
    scan() {
      document.querySelectorAll('.search-filters__product-item, .product-card-wrapper').forEach(card => {
        const info = card.querySelector('.search-filters__product-info, .card-information');
        const link = card.querySelector('a[href*="/products/"]');
        if (!info || !link) return;
        const url = new URL(link.href, location.origin);
        if (url.origin !== location.origin) return;
        const match = url.pathname.match(/^(.*\/products\/[^/]+)/);
        if (!match) return;
        const path = match[1];
        const previous = this.states.get(info);
        if (previous === path) return;
        info.querySelector('.casland-card-sizes')?.remove();
        this.states.set(info, path);
        this.getProduct(path).then(product => {
          if (!info.isConnected || this.states.get(info) !== path) return;
          const index = product.options.findIndex(option => /^(tallas?|sizes?|tamaños?|numeros?|números?)$/i.test((option.name || option).trim()));
          if (index < 0) return;
          const sizes = [...new Set(product.variants.filter(variant => variant.available).map(variant => variant.options[index]).filter(Boolean))];
          if (!sizes.length) return;
          const row = document.createElement('div');
          row.className = 'casland-card-sizes';
          const label = document.createElement('span');
          label.className = 'casland-card-sizes__label';
          label.textContent = this.dataset.label;
          row.append(label);
          sizes.forEach(size => {
            const pill = document.createElement('span');
            pill.className = 'casland-card-sizes__size';
            pill.textContent = size;
            row.append(pill);
          });
          info.append(row);
        }).catch(() => {});
      });
    }
    getProduct(path) {
      if (!this.cache.has(path)) {
        this.cache.set(path, new Promise((resolve, reject) => {
          this.queue.push({ path, resolve, reject });
          this.pump();
        }));
      }
      return this.cache.get(path);
    }
    pump() {
      while (this.active < 4 && this.queue.length) {
        const task = this.queue.shift();
        this.active++;
        fetch(task.path + '.js', { credentials: 'same-origin' })
          .then(response => { if (!response.ok) throw new Error('Product unavailable'); return response.json(); })
          .then(task.resolve, task.reject)
          .finally(() => { this.active--; this.pump(); });
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
